// Parses a comma-separated IATA code list (e.g. "AF, u2") — trims, uppercases, drops empty segments.
export const parseIataCodeList = (raw: string): string[] =>
  raw
    .split(',')
    .map((code) => code.trim().toUpperCase())
    .filter((code) => code.length > 0);
